// extracted by mini-css-extract-plugin
export default {"Link":"index__Link__Svurl","disabled":"index__disabled__VBMfX"};